import { render, staticRenderFns } from "./McrItemNote.vue?vue&type=template&id=3b4ac540"
import script from "./McrItemNote.vue?vue&type=script&lang=js"
export * from "./McrItemNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports